module.exports = __webpack_public_path__ + "img/geniads.8b835f3b.svg";